module.exports = __webpack_public_path__ + "static/img/wechat2.8b29a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat2.jpg
// module id = Dl10
// module chunks = 16